import I18n from 'I18n';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import FormattedList from 'I18n/components/FormattedList';
import { Small } from 'foundations-components/transitional/components/Small';
import { useGetTranslatedLabels } from '../dataAccessHelpers/getTranslatedLabels';
import { useGetAssociationLabelsPrefix } from '../hooks/useGetAssociationLabelsPrefix';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ChickletAssociationLabels = ({
  associationDefinitions
}) => {
  const translatedLabels = useGetTranslatedLabels(associationDefinitions);
  const prefixText = useGetAssociationLabelsPrefix(associationDefinitions);
  if (!translatedLabels) {
    return null;
  }
  const formattedLabels = /*#__PURE__*/_jsx(TruncateString, {
    children: /*#__PURE__*/_jsx(FormattedList, {
      lastWordConnector: I18n.text('cardAssociatedObjects.chicklet.AssociationChicklet.delimiter'),
      twoWordsConnector: I18n.text('cardAssociatedObjects.chicklet.AssociationChicklet.delimiter'),
      children: translatedLabels.map(label => label)
    })
  });
  if (prefixText) {
    return /*#__PURE__*/_jsxs(Flex, {
      flexDirection: "row",
      "data-selenium-test": "chicklet-association-label",
      "data-test-id": "chicklet-association-label",
      children: [/*#__PURE__*/_jsx(Text, {
        textWrap: "nowrap",
        paddingInlineEnd: "100",
        children: prefixText
      }), formattedLabels]
    });
  }
  return /*#__PURE__*/_jsx(Small, {
    use: "help",
    weight: "demi",
    "data-selenium-test": "chicklet-association-label",
    "data-test-id": "chicklet-association-label",
    children: formattedLabels
  });
};
export default ChickletAssociationLabels;